import request from '../../axios';
import {ICreateOrderTransactionPayload} from './types';

const postPaymentOrderTransaction = async (
  payload: ICreateOrderTransactionPayload,
) => {
  const {data} = await request.post(
    `/api/v2/payment/payment-order-transaction`,
    payload,
  );
  return data;
};

export default postPaymentOrderTransaction;
